/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoicestatuspaid2Inputs */

const en_invoicestatuspaid2 = /** @type {(inputs: Invoicestatuspaid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paid`)
};

const de_invoicestatuspaid2 = /** @type {(inputs: Invoicestatuspaid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezahlt`)
};

/**
* | output |
* | --- |
* | "Paid" |
*
* @param {Invoicestatuspaid2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const invoicestatuspaid2 = /** @type {((inputs?: Invoicestatuspaid2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoicestatuspaid2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invoicestatuspaid2(inputs)
	return de_invoicestatuspaid2(inputs)
});
export { invoicestatuspaid2 as "invoiceStatusPaid" }